import { useSelector } from "react-redux"

const MONEY_DECIMALS = 2

const toFixedMoney = (val) => {
    const num = Number(val || 0)
    if (Number.isNaN(num)) return (0).toFixed(MONEY_DECIMALS)
    return num.toFixed(MONEY_DECIMALS)
}

export const CalculateProductPrice = (props)=>{
    const authtoken=props.authtoken || localStorage.getItem('authtoken')
    const member=props.member
    const item = props.item
    const strike=props.lineStrike
    // console.log("-------",item.product)
    // if(authtoken && !strike){
    if(!strike){

        return toFixedMoney(parseFloat(item.product?.selling_price) + (parseFloat(item.product?.selling_price) * (parseFloat(item.product?.tax)/100)  ))
    }
    return toFixedMoney(parseFloat(item.product?.price) + (item.product?.price * (item.product?.tax/100) ))
}
